import axios from 'axios';
import { API_BASE_URL, SEARCH_URL } from '../config/config';

// Add this new function for checking sale page status
export const checkSalePageStatus = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/products/get-sale-page-status/`);
    return response.data;
  } catch (error) {
    console.error('Error checking sale page status:', error);
    throw error;
  }
};

// Add this new function for fetching sale products
export const fetchSaleProducts = async (queryString) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/user/products/get-sale-products/${queryString ? `?${queryString}` : ''}`);
    if (response.data.status === 0) {
      throw new Error(response.data.message);
    }
    return response.data.data;
  } catch (error) {
    console.error('Error fetching sale products:', error);
    throw error;
  }
};

// Merged fetch_Products function keeping query string functionality
export const fetch_Products = async (queryString = "") => {
  try {
    // If a query string is provided, it appends it to the base URL, otherwise just calls the base URL
    const url = queryString
      ? `${API_BASE_URL}/user/products/get-recent/?${queryString}`
      : `${API_BASE_URL}/user/products/get-recent/`;
    const response = await axios.get(url);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const fetchRecentProducts = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/user/products/get-recent/`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching recent product data:', error);
    throw error;
  }
};

export const fetchProductBySlug = async (slug) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/user/products/get-product-by-slug/?slug=${slug}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching product by slug:', error);
    throw error;
  }
};

export const fetchProductData = async (query) => {
  if (!query) {
    console.log('No query provided, skipping search');
    return [];
  }
  try {
    const url = `${SEARCH_URL}?kw=${encodeURIComponent(query)}`;
    const response = await axios.get(url);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching product data:', error);
    throw error;
  }
};

export const fetchOrderDetails = async (userId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/user/order/all/?id=${userId}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching order details:', error);
    throw error;
  }
};